"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const legacyVariableDisplayNames_1 = __importDefault(require("./legacyVariableDisplayNames"));
// Only for FE use. These serve as FE IDs for the deprecated columns.
// For a limited period, we allow use of certain deprecated columns in custom functions. This will also block users from making new columns using these keywords.
// Will be migrated to new plan models.
const legacyVariableNames = Object.freeze({
    CUSTOMERS: "利用人数",
    REVENUE: "売上",
    REQUIRED_STAFF: "必要人数",
    MEMO: `${legacyVariableDisplayNames_1.default.MEMO}deprecated`,
});
exports.default = legacyVariableNames;
